

export const error = (state = {}, action) => {
    const { error } = action.payload;
    if (!error) {
        return state;
    }
    if (error.modelState) {
        return error.modelState;
    }
    if (error.name === 'ValidationError') {
        if (error.inner && error.inner.length > 0) {
            const errors = {};
            for(let i = 0; i < error.inner.length; i++){
                errors[error.inner[i].path] = error.inner[i].errors[0];
            };

            return { 
                errorsList: errors
            }
        }

        return {
            [error.path]: error.errors,
        };
    }
    return state;
}

export const errorNoAction = (error) => {
    let errorList = {}
    if (!error) {
        return error;
    }
    if (error.modelState) {
        return error.modelState;
    }

    error.inner.map(err => {
        if (err.name === 'ValidationError') {
            errorList[err.path] = err.errors;
        }
    });

    return errorList;
}